/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  REQUEST_ROBOTS,
  FETCH_ROBOTS_SUCCESS,
  FETCH_ROBOTS_FAILURE,
  CREATE_ROBOTS,
  CREATE_ROBOTS_SUCCESS,
  CREATE_ROBOTS_FAILURE,
  REQUEST_ROBOTS_FOR_UPGRADE,
  FETCH_ROBOTS_FOR_UPGRADE_SUCCESS,
  FETCH_ROBOTS_FOR_UPGRADE_FAILURE,
  DEPLOY_ROBOTS,
  DEPLOY_ROBOTS_SUCCESS,
  DEPLOY_ROBOTS_FAILURE,
} from './actionTypes'
import { Robots as robotsApi } from './robots'

export function requestRobots() {
  return {
    type: REQUEST_ROBOTS,
  }
}

export function fetchRobotsSuccess(json) {
  return {
    type: FETCH_ROBOTS_SUCCESS,
    robots: json,
  }
}

export function fetchRobotsFailure(error) {
  return {
    type: FETCH_ROBOTS_FAILURE,
    errorMessage: error.message,
  }
}

export function fetchRobots() {
  return dispatch => {
    dispatch(requestRobots())
    return robotsApi
      .get()
      .then(response => response.data)
      .then(json => dispatch(fetchRobotsSuccess(json)))
      .catch(function(error) {
        dispatch(fetchRobotsFailure(error))
      })
  }
}

export function pollFetchRobots() {
  return dispatch => {
    return robotsApi
      .get()
      .then(response => response.data)
      .then(json => dispatch(fetchRobotsSuccess(json)))
      .catch(function(error) {
        dispatch(fetchRobotsFailure(error))
      })
  }
}

export function createRobots() {
  return {
    type: CREATE_ROBOTS,
  }
}

export function createRobotsSuccess(json) {
  return {
    type: CREATE_ROBOTS_SUCCESS,
    robots: json,
  }
}

export function createRobotsFailure(error) {
  return {
    type: CREATE_ROBOTS_FAILURE,
    errorMessage: error.message,
    error: error,
  }
}

export function saveRobots(data) {
  return dispatch => {
    dispatch(createRobots())
    const promise = robotsApi.post(data)
    promise
      .then(response => response.data)
      .then(json => {
        return dispatch(createRobotsSuccess(json))
      })
      .catch(function(error) {
        dispatch(createRobotsFailure(error))
      })
    return promise
  }
}
export function deployRobots() {
  return {
    type: DEPLOY_ROBOTS,
  }
}

export function deployRobotsSuccess(json) {
  return {
    type: DEPLOY_ROBOTS_SUCCESS,
    robots: json,
  }
}

export function deployRobotsFailure(error) {
  return {
    type: DEPLOY_ROBOTS_FAILURE,
    errorMessage: error.message,
    error: error,
  }
}
export function deployRobot(data) {
  return dispatch => {
    dispatch(deployRobots())
    const promise = robotsApi.deployRobot(data)
    promise
      .then(response => response.data)
      .then(json => {
        return dispatch(deployRobotsSuccess(json))
      })
      .catch(function(error) {
        dispatch(deployRobotsFailure(error))
      })
    return promise
  }
}

export function requestRobotsForUpgrade() {
  return {
    type: REQUEST_ROBOTS_FOR_UPGRADE,
  }
}

export function fetchRobotsForUpgradeSuccess(json) {
  return {
    type: FETCH_ROBOTS_FOR_UPGRADE_SUCCESS,
    robots: json,
  }
}

export function fetchRobotsForUpgradeFailure(error) {
  return {
    type: FETCH_ROBOTS_FOR_UPGRADE_FAILURE,
    errorMessage: error.message,
  }
}

export function fetchUpgradeableRobots() {
  return dispatch => {
    dispatch(requestRobotsForUpgrade())
    return robotsApi
      .getRobotsForUpgrade()
      .then(response => response.data)
      .then(json => dispatch(fetchRobotsForUpgradeSuccess(json)))
      .catch(function(error) {
        dispatch(fetchRobotsForUpgradeFailure(error))
      })
  }
}
